import { render, staticRenderFns } from "./approvedList.vue?vue&type=template&id=6b4c5a09&scoped=true&"
import script from "./approvedList.vue?vue&type=script&lang=js&"
export * from "./approvedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4c5a09",
  null
  
)

export default component.exports